import { Fragment, type ComponentProps, type ReactNode } from 'react';

import { cn } from '../lib/cn';

/**
 * 한 대상의 속성값 목록 — 라벨(`dt`)과 값(`dd`)이 짝을 이룬다.
 * `grid`는 라벨 열이 내용 폭, `stack`은 라벨이 값 위에 온다(값이 길 때).
 */
export interface DescriptionListItem {
  key?: string;
  term: ReactNode;
  detail: ReactNode;
}

export interface DescriptionListProps extends ComponentProps<'dl'> {
  items: ReadonlyArray<DescriptionListItem>;
  /** @default 'grid' */
  layout?: 'grid' | 'stack';
}

export function DescriptionList({
  items,
  layout = 'grid',
  className,
  ...props
}: DescriptionListProps) {
  if (layout === 'stack') {
    return (
      <dl className={cn('gap-row flex flex-col text-sm', className)} {...props}>
        {items.map((item, index) => (
          <div key={item.key ?? index} className="gap-tight flex flex-col">
            <dt className="text-ink-muted">{item.term}</dt>
            <dd className="text-ink">{item.detail}</dd>
          </div>
        ))}
      </dl>
    );
  }

  return (
    <dl
      className={cn(
        'gap-x-snug gap-y-row grid grid-cols-[auto_minmax(0,1fr)] items-baseline text-sm',
        className,
      )}
      {...props}
    >
      {items.map((item, index) => (
        <Fragment key={item.key ?? index}>
          <dt className="text-ink-muted">{item.term}</dt>
          <dd className="text-ink">{item.detail}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
